export default __webpack_public_path__ + "static/media/nfo_checkout_cart_banner_mobile_service_fund.9b7a48c1.svg";